import {Component, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {AuthenticationService} from "../../services/authentication.service";

import {hasLinkedAccount} from "../../core/utils";
import {LinkAccountComponent} from "../link-account/link-account.component";

@Component({
  selector: 'app-link-account-hint',
  standalone: true,
  imports: [
    LinkAccountComponent
],
  templateUrl: './link-account-hint.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './link-account-hint.component.scss'
})
export class LinkAccountHintComponent implements OnInit {
  hasLinkedAccount: boolean = false;
  @ViewChild(LinkAccountComponent) linkAccountComponent!: LinkAccountComponent;

  constructor(private authService: AuthenticationService) {
  }

  ngOnInit() {
    this.authService.user$.subscribe({
      next: () => this.hasLinkedAccount = hasLinkedAccount(this.authService)
    });
  }

  linkAccount() {
    this.linkAccountComponent.show();
  }
}
